import * as React from 'react';
import {lazy, Suspense} from "react";
import {BrowserRouter, Routes, Route} from 'react-router-dom';
import VenditaAdd from "../pages/fatture/venditaAdd";
import VenditaEdit from "../pages/fatture/venditaEdit";

const Home = lazy(() => import("../pages/home"));
const Schede = lazy(() => import("../pages/schede/schede"));
const Edit = lazy(() => import("../pages/schede/edit"));
const Add = lazy(() => import("../pages/schede/add"));
const Single = lazy(() => import("../pages/schede/single"));
const List = lazy(() => import("../pages/schede/list"));
const Autori = lazy(() => import("../pages/autori/autori"));
const AutoriEdit = lazy(() => import("../pages/autori/autoriEdit"));
const AutoriNew = lazy(() => import("../pages/autori/autoriNew"));
const Opere = lazy(() => import("../pages/opere/opere"));
const OpereEdit = lazy(() => import("../pages/opere/opereEdit"));
const OpereNew = lazy(() => import("../pages/opere/opereNew"));
const Localizzazioni = lazy(() => import("../pages/localizzazioni/localizzazioni"));
const LocalizzazioniEdit = lazy(() => import("../pages/localizzazioni/localizzazioniEdit"));
const LocalizzazioniNew = lazy(() => import("../pages/localizzazioni/localizzazioniNew"));
const Gruppi = lazy(() => import("../pages/gruppi/gruppi"));
const GruppiEdit = lazy(() => import("../pages/gruppi/gruppiEdit"));
const GruppiNew = lazy(() => import("../pages/gruppi/gruppiNew"));
const Report = lazy(() => import("../pages/reports/index"));
const AutoreReport = lazy(() => import("../pages/reports/autore"));
const Vendita = lazy(() => import("../pages/fatture/vendita"));
const Acquisto = lazy(() => import("../pages/fatture/acquisto"));
const AcquistoAdd = lazy(() => import("../pages/fatture/acquistoAdd"));
const AcquistoEdit = lazy(() => import("../pages/fatture/acquistoEdit"));
const Utenti = lazy(() => import("../pages/utenti/utenti"));
const UtentiNew = lazy(() => import("../pages/utenti/utentiNew"));
const UtentiEdit = lazy(() => import("../pages/utenti/utentiEdit"));
const Ruoli = lazy(() => import("../pages/ruoli/ruoli"));
const RuoliNew = lazy(() => import("../pages/ruoli/ruoliNew"));
const RuoliEdit = lazy(() => import("../pages/ruoli/ruoliEdit"));
const Permessi = lazy(() => import("../pages/permessi/permessi"));
const PermessiNew = lazy(() => import("../pages/permessi/permessiNew"));
const PermessiEdit = lazy(() => import("../pages/permessi/permessiEdit"));
const Log = lazy(() => import("../pages/log/log"));
const Clienti = lazy(() => import("../pages/clienti/clienti"));
const ClientiNew = lazy(() => import("../pages/clienti/clientiNew"));
const ClientiEdit = lazy(() => import("../pages/clienti/clientiEdit"));

export const Main = () => {
    return (
        <Suspense fallback={<div></div>}>
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Schede/>}/>
                    <Route path="/schede" element={<Schede/>}/>
                    <Route path="/scheda/single/:id" element={<Single/>}/>
                    <Route path="/schede/:id" element={<List/>}/>
                    <Route path="/scheda/aggiungi" element={<Add/>}/>
                    <Route path="/schede/aggiungi" element={<Add/>}/>
                    <Route path="/scheda/edit/:id" element={<Edit/>}/>
                    <Route path="/autori" element={<Autori/>}/>
                    <Route path="/autori/edit/:id" element={<AutoriEdit/>}/>
                    <Route path="/autori/aggiungi" element={<AutoriNew/>}/>
                    <Route path="/opere" element={<Opere/>}/>
                    <Route path="/opere/edit/:id" element={<OpereEdit/>}/>
                    <Route path="/opere/aggiungi" element={<OpereNew/>}/>
                    <Route path="/localizzazioni" element={<Localizzazioni/>}/>
                    <Route path="/localizzazioni/edit/:id" element={<LocalizzazioniEdit/>}/>
                    <Route path="/localizzazione/aggiungi" element={<LocalizzazioniNew/>}/>
                    <Route path="/gruppi" element={<Gruppi/>}/>
                    <Route path="/gruppi/edit/:id" element={<GruppiEdit/>}/>
                    <Route path="/gruppi/aggiungi" element={<GruppiNew/>}/>
                    <Route path="/reports" element={<Report/>}/>
                    <Route path="/reports/:id" element={<AutoreReport/>}/>
                    <Route path="/fatture/vendita" element={<Vendita/>}/>
                    <Route path="/fatture/acquisto" element={<Acquisto/>}/>
                    <Route path="/fatture/vendita/add" element={<VenditaAdd/>}/>
                    <Route path="/fatture/vendita/aggiungi" element={<VenditaAdd/>}/>
                    <Route path="/fatture/vendita/edit/:id" element={<VenditaEdit/>}/>
                    <Route path="/fatture/acquisto/add" element={<AcquistoAdd/>}/>
                    <Route path="/fatture/acquisto/aggiungi" element={<AcquistoAdd/>}/>
                    <Route path="/fatture/acquisto/edit/:id" element={<AcquistoEdit/>}/>
                    <Route path="/utenti" element={<Utenti/>}/>
                    <Route path="/utenti/aggiungi" element={<UtentiNew/>}/>
                    <Route path="/utenti/edit/:id" element={<UtentiEdit/>}/>
                    <Route path="/ruoli" element={<Ruoli/>}/>
                    <Route path="/ruoli/aggiungi" element={<RuoliNew/>}/>
                    <Route path="/ruoli/edit/:id" element={<RuoliEdit/>}/>
                    <Route path="/permessi" element={<Permessi/>}/>
                    <Route path="/permessi/aggiungi" element={<PermessiNew/>}/>
                    <Route path="/permessi/edit/:id" element={<PermessiEdit/>}/>
                    <Route path="/log" element={<Log/>}/>
                    <Route path="/clienti" element={<Clienti/>}/>
                    <Route path="/clienti/aggiungi" element={<ClientiNew/>}/>
                    <Route path="/clienti/edit/:id" element={<ClientiEdit/>}/>
                </Routes>
            </BrowserRouter>
        </Suspense>
    );
};

export default Main;
